import PhotoSwipeLightbox from 'photoswipe/lightbox'
import 'photoswipe/style.css'

// const arrowSVGString =
//   '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 60 60" width="60" height="60"><path class="fill-dark-950" d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z"></path></svg>'

export const lightbox = new PhotoSwipeLightbox({
  bgOpacity: 1,
  mainClass: 'pswp--custom-bg',
  showHideAnimationType: 'fade',
  // arrowPrevSVG: arrowSVGString,
  // arrowNextSVG: arrowSVGString,
  zoom: false,
  close: false,
  counter: false,
  arrowPrev: false,
  arrowNext: false,
  gallery: '#rich-content',
  children: '.lightbox-image',
  tapAction: 'close',
  imageClickAction: 'close',

  // tap delay is removed if set to false
  doubleTapAction: false,

  pswpModule: () => import('photoswipe'),
  paddingFn: (viewportSize) => {
    return {
      top: 20,
      bottom: 20,
      left: viewportSize.x < 768 ? 0 : 70,
      right: viewportSize.x < 768 ? 0 : 70,
    }
  },
})

// Handle images with missing width/height by loading the image to get natural dimensions
lightbox.addFilter('itemData', (itemData) => {
  // If width or height are missing/invalid, we need to load the image to get dimensions
  if (!itemData.w || !itemData.h) {
    const img = new Image()
    img.src = itemData.src || ''

    // If image is already cached, naturalWidth/Height will be available immediately
    if (img.naturalWidth && img.naturalHeight) {
      itemData.w = img.naturalWidth
      itemData.h = img.naturalHeight
    } else {
      // Set placeholder dimensions, PhotoSwipe will update when image loads
      // Using 4:3 aspect ratio as a reasonable default for screenshots
      itemData.w = 1600
      itemData.h = 1200
    }
  }
  return itemData
})
